// function ItchShowcase() {
//   return (
//     <div id="itch-showcase" style={{}}>
//       <a href="https://bates550.itch.io/sharon-goes-to-charon">
//         Sharon Goes to Charon
//       </a>
//     </div>
//   );
// }

// export default ItchShowcase;

// import useWindowDimensions from '../hooks/useWindowDimensions'
import Carousel from "better-react-carousel";

const projects = [
  {
    title: "Sharon Goes to Charon",
    imgRef: require("../../projects/sharon-goes-to-charon/splash.gif"),
    description: "Nokia 3310 Game Jam project created in PixiJS.",
    link: "https://bates550.itch.io/sharon-goes-to-charon",
  },
];

function Project({
  title,
  imgRef,
  description,
  link,
  imgAlt = "Project image",
}) {
  return (
    <div className="project-item">
      <a href={link} className="project-link">
        <img src={imgRef} alt={imgAlt} className="project-image" />
        <h4 className="project-title">{title}</h4>
      </a>
      <p className="project-description">{description}</p>
    </div>
  );
}

function ProjectsCarousel() {
  return (
    <div id="projects-container" className="bgc-ddd">
      <h3>Projects</h3>
      <Carousel
        cols={1}
        rows={1}
        gap="10%"
        loop
        mobileBreakpoint={654}
        scrollSnap={true}
      >
        {projects.map((project, i) => (
          <Carousel.Item key={i}>
            <Project {...project} />
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
}

export default ProjectsCarousel;
